import { useState } from "react";
import moment from "moment";
import { toastr } from "react-redux-toastr";
import { client_v2, getApiErrorMessage } from "utils/api";
import UserAdjustmentModal from "./components/UserAdjustmentModal";

const PayoutItem = ({
  date,
  refetch,
  tradecoin_transaction,
  user_id,
  full_name,
  balance,
  can_generate_payout,
}) => {
  const [is_open_user_adjustment_modal, setOpenUserAdjustmentModal] =
    useState(false);
  const [is_generating, setGenerating] = useState(false);

  const generatePayout = async () => {
    try {
      setGenerating(true);
      await client_v2.post(
        `/tradecoin_transactions/payout?user_id=${user_id}&date=${date}`
      );
      await refetch();
    } catch (error) {
      toastr.error("Błąd", getApiErrorMessage(error));
    } finally {
      setGenerating(false);
    }
  };

  return (
    <tr key={user_id}>
      {is_open_user_adjustment_modal && (
        <UserAdjustmentModal
          date={date}
          user_id={user_id}
          full_name={full_name}
          refetch={refetch}
          handleClose={() => setOpenUserAdjustmentModal()}
        />
      )}
      <td>
        <p>
          <a
            className="link"
            href={`/packer_stats?packer_id=${user_id}&tab=transactions&date=${moment(
              date
            ).format("YYYY-MM-DD")}`}
          >
            {full_name}
          </a>
        </p>
      </td>
      <td>
        {balance !== "0.0" ? (
          <strong
            className={
              balance > 0 ? "text-success" : balance < 0 ? "text-danger" : ""
            }
          >
            {balance > 0 ? "+" : ""}
            {balance ? parseFloat(balance)?.toFixed(2) : balance}
          </strong>
        ) : (
          "-"
        )}
      </td>
      <td>
        {tradecoin_transaction ? (
          <strong>{(tradecoin_transaction?.amount * -1).toFixed(2)}</strong>
        ) : (
          <div className="row" style={{ gap: 10 }}>
            {can_generate_payout && (
              <button
                type="button"
                className="btn btn-sm btn-info"
                disabled={is_generating}
                onClick={generatePayout}
              >
                {is_generating ? "Proszę czekać..." : "Potwierdź wypłatę"}
              </button>
            )}
            <button
              type="button"
              className="btn btn-sm btn-danger"
              onClick={() => setOpenUserAdjustmentModal(true)}
            >
              Dodaj uwagę
            </button>
          </div>
        )}
      </td>
    </tr>
  );
};

const PayoutTransactions = ({
  date,
  refetch,
  data,
  packers,
  user_balances,
}) => {
  const balance_to_payout = data
    .filter(({ amount }) => amount < 0)
    .sort((a, b) => a.amount - b.amount);

  const saldo_minus = data
    .filter(({ balance_after }) => balance_after !== 0)
    .sort((a, b) => a.balance_after - b.balance_after);

  const balance_to_payout_total = balance_to_payout.reduce(
    (acc, { amount }) => acc + amount * -1,
    0
  );

  return (
    <div className="row row--with-spaces">
      <div className="box-6">
        <div className="dashboard">
          <div className="dashboard__header">
            <h2 className="dashboard__title heading m-l-0">
              Monety do wypłaty
            </h2>
          </div>
          <table className="table table-sm">
            <thead className="table__header">
              <tr>
                <th>Imię i nazwisko</th>
                <th>Saldo</th>
                <th width="300px">Wypłata</th>
              </tr>
            </thead>
            <tbody className="table__body">
              {packers?.map(({ id, first_name, last_name }) => {
                const tradecoin_transaction = data.find(({ user_ids }) =>
                  user_ids.includes(id)
                );

                const balance = user_balances.find(({ user_ids }) =>
                  user_ids.includes(id)
                )?.balance;

                const can_generate_payout = user_balances.find(({ user_ids }) =>
                  user_ids.includes(id)
                )?.can_generate_payout;

                return (
                  <PayoutItem
                    tradecoin_transaction={tradecoin_transaction}
                    date={date}
                    refetch={refetch}
                    user_id={id}
                    full_name={`${first_name} ${last_name}`}
                    balance={balance}
                    can_generate_payout={can_generate_payout}
                  />
                );
              })}
              <tr style={{ borderTop: "2px solid #e9ecef" }}>
                <td>
                  <strong>Suma</strong>
                </td>
                <td>
                  <strong>{balance_to_payout_total.toFixed(2)}</strong>
                </td>
                <td />
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="box-6">
        <div className="dashboard">
          <div className="dashboard__header">
            <h2 className="dashboard__title heading m-l-0">Salda ujemne</h2>
          </div>
          <table className="table table-sm">
            <thead className="table__header">
              <tr>
                <th width="50%">Imię i nazwisko</th>
                <th width="50%">Saldo</th>
              </tr>
            </thead>
            <tbody className="table__body">
              {saldo_minus.map(({ user_full_name, balance_after }) => (
                <tr key={user_full_name}>
                  <td>
                    <p>{user_full_name}</p>
                  </td>

                  <td>
                    <strong className="text-danger">
                      {balance_after.toFixed(2)}
                    </strong>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default PayoutTransactions;
